import { render } from "./StatusDistribution.vue?vue&type=template&id=0798c5ce&scoped=true"
import script from "./StatusDistribution.vue?vue&type=script&lang=js"
export * from "./StatusDistribution.vue?vue&type=script&lang=js"

import "./StatusDistribution.vue?vue&type=style&index=0&id=0798c5ce&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0798c5ce"]])

export default __exports__